"use client";

import { useSEOBannerVisibility } from "@/hooks/use-seo-banner-visibility";
import { useSearchPageMapData } from "@/providers/search";
import { SearchList } from "../list";
import { SEOContentForSearch } from "../list/seo/content";
import { SearchMap } from "../map";
import { ProjectList } from "../project-list";

export function DesktopLayout() {
	const { shouldShowSeoBanner, totalPropertiesCount } = useSEOBannerVisibility();
	const mode = useSearchPageMapData(state => state.mode);

	return (
		<div className="w-full h-full flex flex-col">
			{/* Main content area: calc height excluding header */}
			<div className="flex w-full h-[calc(100vh-var(--header-height))]">
				<div className="w-1/2 h-full">
					{mode === "project" && <ProjectList className="h-full" />}
					{mode !== "project" && <SearchList className="h-full" />}
				</div>
				<div className="w-1/2 h-full">
					<SearchMap />
				</div>
			</div>

			{/* SEO Banner: pulled to be sibling of list/map container */}
			{shouldShowSeoBanner && totalPropertiesCount > 0 && (
				<div className="w-full bg-gradient-to-r from-[#251821] to-[#31202C] min-h-[20vh] flex items-center justify-center">
					<SEOContentForSearch />
				</div>
			)}
		</div>
	);
}
